import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch } from '../hooks';
import { DeviceButton2 } from '../components/DeviceButton';
import { zigbeeOn } from '../actions/ZigbeeOn';
import { zigbeeOff } from '../actions/ZigbeeOff';
import { useAttributeState } from '../features/zigbee/ZigbeeAttributesSlice';
export const DeviceButtonsZigbee = props => {
    const attrVal = useAttributeState(props.node_id, props.endpoint_id, 6, 0); // onoff value
    const dispatch = useAppDispatch();
    let s1, s2;
    if ((attrVal === null || attrVal === void 0 ? void 0 : attrVal.typedValue.type) == 'Bool' && (attrVal === null || attrVal === void 0 ? void 0 : attrVal.typedValue.value) != undefined) {
        if (attrVal.typedValue.value) {
            s1 = undefined;
            s2 = 'on';
        }
        else {
            s1 = 'off';
            s2 = undefined;
        }
    }
    else {
        s1 = undefined;
        s2 = undefined;
    }
    return (_jsxs("div", { className: "transmitter-buttons lw-button-group", children: [_jsx(DeviceButton2, { state: s1, onClick: () => dispatch(zigbeeOff(props.node_id, props.endpoint_id)), children: "Av" }), _jsx(DeviceButton2, { state: s2, onClick: () => dispatch(zigbeeOn(props.node_id, props.endpoint_id)), children: "P\u00E5" })] }));
};
